import { LanguageCode } from "./language-codes"

export interface Language {
    name: string
    nativeName: string
    /**
     * ISO 639-1
     */
    code: LanguageCode
    /**
     * ISO 639-2
     */
    code2: string
    /**
     * ISO 639-3
     */
    code3: string
  }
  
export const languages: Language[] = [
    {
      name: 'Serbian',
      nativeName: 'српски језик',
      code: 'sr',
      code2: 'srp',
      code3: 'srp',
    },
    {
      name: 'Romanian, Moldavian, Moldovan',
      nativeName: 'Română',
      code: 'ro',
      code2: 'ron',
      code3: 'rum',
    },
    {
      name: 'Sichuan Yi, Nuosu',
      nativeName: 'ꆈꌠ꒿ Nuosuhxop',
      code: 'ii',
      code2: 'iii',
      code3: 'iii',
    },
    {
      name: 'Tahitian',
      nativeName: 'Reo Tahiti',
      code: 'ty',
      code2: 'tah',
      code3: 'tah',
    },
    {
      name: 'Tagalog',
      nativeName: 'Wikang Tagalog',
      code: 'tl',
      code2: 'tgl',
      code3: 'tgl',
    },
    {
      name: 'Yiddish',
      nativeName: 'ייִדיש',
      code: 'yi',
      code2: 'yid',
      code3: 'yid',
    },
    {
      name: 'Akan',
      nativeName: 'Akan',
      code: 'ak',
      code2: 'aka',
      code3: 'aka',
    },
    {
      name: 'Malay',
      nativeName: 'Bahasa Melayu, بهاس ملايو',
      code: 'ms',
      code2: 'msa',
      code3: 'may',
    },
    {
      name: 'Arabic',
      nativeName: 'العربية',
      code: 'ar',
      code2: 'ara',
      code3: 'ara',
    },
    {
      name: 'Norwegian',
      nativeName: 'Norsk',
      code: 'no',
      code2: 'nor',
      code3: 'nor',
    },
    {
      name: 'Ojibwa',
      nativeName: 'ᐊᓂᔑᓈᐯᒧᐎᓐ',
      code: 'oj',
      code2: 'oji',
      code3: 'oji',
    },
    {
      name: 'Fulah',
      nativeName: 'Fulfulde, Pulaar, Pular',
      code: 'ff',
      code2: 'ful',
      code3: 'ful',
    },
    {
      name: 'Persian',
      nativeName: 'فارسی',
      code: 'fa',
      code2: 'fas',
      code3: 'per',
    },
    {
      name: 'Albanian',
      nativeName: 'Shqip',
      code: 'sq',
      code2: 'sqi',
      code3: 'alb',
    },
    {
      name: 'Aymara',
      nativeName: 'aymar aru',
      code: 'ay',
      code2: 'aym',
      code3: 'aym',
    },
    {
      name: 'Azerbaijani',
      nativeName: 'azərbaycan dili',
      code: 'az',
      code2: 'aze',
      code3: 'aze',
    },
    {
      name: 'Chinese',
      nativeName: '中文 (Zhōngwén), 汉语, 漢語',
      code: 'zh',
      code2: 'zho',
      code3: 'chi',
    },
    {
      name: 'Cree',
      nativeName: 'ᓀᐦᐃᔭᐍᐏᐣ',
      code: 'cr',
      code2: 'cre',
      code3: 'cre',
    },
    {
      name: 'Estonian',
      nativeName: 'eesti, eesti keel',
      code: 'et',
      code2: 'est',
      code3: 'est',
    },
    {
      name: 'Guaraní',
      nativeName: "Avañe'ẽ",
      code: 'gn',
      code2: 'grn',
      code3: 'grn',
    },
    {
      name: 'Inupiaq',
      nativeName: 'Iñupiaq, Iñupiatun',
      code: 'ik',
      code2: 'ipk',
      code3: 'ipk',
    },
    {
      name: 'Inuktitut',
      nativeName: 'ᐃᓄᒃᑎᑐᑦ',
      code: 'iu',
      code2: 'iku',
      code3: 'iku',
    },
    {
      name: 'Kanuri',
      nativeName: 'Kanuri',
      code: 'kr',
      code2: 'kau',
      code3: 'kau',
    },
    {
      name: 'Komi',
      nativeName: 'коми кыв',
      code: 'kv',
      code2: 'kom',
      code3: 'kom',
    },
    {
      name: 'Kongo',
      nativeName: 'Kikongo',
      code: 'kg',
      code2: 'kon',
      code3: 'kon',
    },
    {
      name: 'Kurdish',
      nativeName: 'Kurdî, أۇزبېك',
      code: 'ku',
      code2: 'kur',
      code3: 'kur',
    },
    {
      name: 'Latvian',
      nativeName: 'latviešu valoda',
      code: 'lv',
      code2: 'lav',
      code3: 'lav',
    },
    {
      name: 'Malagasy',
      nativeName: 'fiteny malagasy',
      code: 'mg',
      code2: 'mlg',
      code3: 'mlg',
    },
    {
      name: 'Mongolian',
      nativeName: 'Монгол хэл',
      code: 'mn',
      code2: 'mon',
      code3: 'mon',
    },
    {
      name: 'Oromo',
      nativeName: 'Afaan Oromoo',
      code: 'om',
      code2: 'orm',
      code3: 'orm',
    },
    {
      name: 'Pashto, Pushto',
      nativeName: 'پښتو',
      code: 'ps',
      code2: 'pus',
      code3: 'pus',
    },
    {
      name: 'Quechua',
      nativeName: 'Runa Simi, Kichwa',
      code: 'qu',
      code2: 'que',
      code3: 'que',
    },
    {
      name: 'Sardinian',
      nativeName: 'sardu',
      code: 'sc',
      code2: 'srd',
      code3: 'srd',
    },
    {
      name: 'Swahili',
      nativeName: 'Kiswahili',
      code: 'sw',
      code2: 'swa',
      code3: 'swa',
    },
    {
      name: 'Uzbek',
      nativeName: 'Oʻzbek, Ўзбек, ',
      code: 'uz',
      code2: 'uzb',
      code3: 'uzb',
    },
    {
      name: 'Zhuang, Chuang',
      nativeName: 'Saɯ cueŋƅ, Saw cuengh',
      code: 'za',
      code2: 'zha',
      code3: 'zha',
    },
    {
      name: 'Bislama',
      nativeName: 'Bislama',
      code: 'bi',
      code2: 'bis',
      code3: 'bis',
    },
    {
      name: 'Norwegian Bokmål',
      nativeName: 'Norsk Bokmål',
      code: 'nb',
      code2: 'nob',
      code3: 'nob',
    },
    {
      name: 'Norwegian Nynorsk',
      nativeName: 'Norsk Nynorsk',
      code: 'nn',
      code2: 'nno',
      code3: 'nno',
    },
    {
      name: 'Indonesian',
      nativeName: 'Bahasa Indonesia',
      code: 'id',
      code2: 'ind',
      code3: 'ind',
    },
    {
      name: 'Twi',
      nativeName: 'Twi',
      code: 'tw',
      code2: 'twi',
      code3: 'twi',
    },
    {
      name: 'Esperanto',
      nativeName: 'Esperanto',
      code: 'eo',
      code2: 'epo',
      code3: 'epo',
    },
    {
      name: 'Interlingua',
      nativeName: 'Interlingua',
      code: 'ia',
      code2: 'ina',
      code3: 'ina',
    },
    {
      name: 'Interlingue',
      nativeName: 'Originally called Occidental; then Interlingue after WWII',
      code: 'ie',
      code2: 'ile',
      code3: 'ile',
    },
    {
      name: 'Ido',
      nativeName: 'Ido',
      code: 'io',
      code2: 'ido',
      code3: 'ido',
    },
    {
      name: 'Volapük',
      nativeName: 'Volapük',
      code: 'vo',
      code2: 'vol',
      code3: 'vol',
    },
    {
      name: 'Bihari languages',
      nativeName: 'भोजपुरी',
      code: 'bh',
      code2: 'bih',
      code3: 'bih',
    },
    {
      name: 'Hebrew (modern)',
      nativeName: 'עברית',
      code: 'he',
      code2: 'heb',
      code3: 'heb',
    },
    {
      name: 'Sanskrit',
      nativeName: 'संस्कृतम्',
      code: 'sa',
      code2: 'san',
      code3: 'san',
    },
    {
      name: 'Church Slavic, Church Slavonic, Old Church Slavonic, Old Slavonic, Old Bulgarian',
      nativeName: 'ѩзыкъ словѣньскъ',
      code: 'cu',
      code2: 'chu',
      code3: 'chu',
    },
    {
      name: 'Pali',
      nativeName: 'पाऴि',
      code: 'pi',
      code2: 'pli',
      code3: 'pli',
    },
    {
      name: 'Avestan',
      nativeName: 'avesta',
      code: 'ae',
      code2: 'ave',
      code3: 'ave',
    },
    {
      name: 'Latin',
      nativeName: 'latine, lingua latina',
      code: 'la',
      code2: 'lat',
      code3: 'lat',
    },
    {
      name: 'Armenian',
      nativeName: 'Հայերեն',
      code: 'hy',
      code2: 'hye',
      code3: 'arm',
    },
    {
      name: 'Swati',
      nativeName: 'SiSwati',
      code: 'ss',
      code2: 'ssw',
      code3: 'ssw',
    },
    {
      name: 'Tibetan',
      nativeName: 'བོད་ཡིག',
      code: 'bo',
      code2: 'bod',
      code3: 'tib',
    },
    {
      name: 'South Ndebele',
      nativeName: 'isiNdebele',
      code: 'nr',
      code2: 'nbl',
      code3: 'nbl',
    },
    {
      name: 'Slovene',
      nativeName: 'Slovenski Jezik, Slovenščina',
      code: 'sl',
      code2: 'slv',
      code3: 'slv',
    },
    {
      name: 'Oriya',
      nativeName: 'ଓଡ଼ିଆ',
      code: 'or',
      code2: 'ori',
      code3: 'ori',
    },
    {
      name: 'North Ndebele',
      nativeName: 'isiNdebele',
      code: 'nd',
      code2: 'nde',
      code3: 'nde',
    },
    {
      name: 'Nauru',
      nativeName: 'Dorerin Naoero',
      code: 'na',
      code2: 'nau',
      code3: 'nau',
    },
    {
      name: 'Maori',
      nativeName: 'te reo Māori',
      code: 'mi',
      code2: 'mri',
      code3: 'mao',
    },
    {
      name: 'Marathi',
      nativeName: 'मराठी',
      code: 'mr',
      code2: 'mar',
      code3: 'mar',
    },
    {
      name: 'Luba-Katanga',
      nativeName: 'Kiluba',
      code: 'lu',
      code2: 'lub',
      code3: 'lub',
    },
    {
      name: 'Rundi',
      nativeName: 'Ikirundi',
      code: 'rn',
      code2: 'run',
      code3: 'run',
    },
    {
      name: 'Central Khmer',
      nativeName: 'ខ្មែរ, ខេមរភាសា, ភាសាខ្មែរ',
      code: 'km',
      code2: 'khm',
      code3: 'khm',
    },
    {
      name: 'Western Frisian',
      nativeName: 'Frysk',
      code: 'fy',
      code2: 'fry',
      code3: 'fry',
    },
    {
      name: 'Bengali',
      nativeName: 'বাংলা',
      code: 'bn',
      code2: 'ben',
      code3: 'ben',
    },
    {
      name: 'Avaric',
      nativeName: 'авар мацӀ, магӀарул мацӀ',
      code: 'av',
      code2: 'ava',
      code3: 'ava',
    },
    {
      name: 'Abkhazian',
      nativeName: 'аҧсуа бызшәа, аҧсшәа',
      code: 'ab',
      code2: 'abk',
      code3: 'abk',
    },
    {
      name: 'Afar',
      nativeName: 'Afaraf',
      code: 'aa',
      code2: 'aar',
      code3: 'aar',
    },
    {
      name: 'Afrikaans',
      nativeName: 'Afrikaans',
      code: 'af',
      code2: 'afr',
      code3: 'afr',
    },
    {
      name: 'Amharic',
      nativeName: 'አማርኛ',
      code: 'am',
      code2: 'amh',
      code3: 'amh',
    },
    {
      name: 'Aragonese',
      nativeName: 'aragonés',
      code: 'an',
      code2: 'arg',
      code3: 'arg',
    },
    {
      name: 'Assamese',
      nativeName: 'অসমীয়া',
      code: 'as',
      code2: 'asm',
      code3: 'asm',
    },
    {
      name: 'Bambara',
      nativeName: 'bamanankan',
      code: 'bm',
      code2: 'bam',
      code3: 'bam',
    },
    {
      name: 'Bashkir',
      nativeName: 'башҡорт теле',
      code: 'ba',
      code2: 'bak',
      code3: 'bak',
    },
    {
      name: 'Basque',
      nativeName: 'euskara, euskera',
      code: 'eu',
      code2: 'eus',
      code3: 'baq',
    },
    {
      name: 'Belarusian',
      nativeName: 'беларуская мова',
      code: 'be',
      code2: 'bel',
      code3: 'bel',
    },
    {
      name: 'Bosnian',
      nativeName: 'bosanski jezik',
      code: 'bs',
      code2: 'bos',
      code3: 'bos',
    },
    {
      name: 'Breton',
      nativeName: 'brezhoneg',
      code: 'br',
      code2: 'bre',
      code3: 'bre',
    },
    {
      name: 'Bulgarian',
      nativeName: 'български език',
      code: 'bg',
      code2: 'bul',
      code3: 'bul',
    },
    {
      name: 'Burmese',
      nativeName: 'ဗမာစာ',
      code: 'my',
      code2: 'mya',
      code3: 'bur',
    },
    {
      name: 'Catalan, Valencian',
      nativeName: 'català, valencià',
      code: 'ca',
      code2: 'cat',
      code3: 'cat',
    },
    {
      name: 'Chamorro',
      nativeName: 'Chamoru',
      code: 'ch',
      code2: 'cha',
      code3: 'cha',
    },
    {
      name: 'Chechen',
      nativeName: 'нохчийн мотт',
      code: 'ce',
      code2: 'che',
      code3: 'che',
    },
    {
      name: 'Chichewa, Chewa, Nyanja',
      nativeName: 'chiCheŵa, chinyanja',
      code: 'ny',
      code2: 'nya',
      code3: 'nya',
    },
    {
      name: 'Chuvash',
      nativeName: 'чӑваш чӗлхи',
      code: 'cv',
      code2: 'chv',
      code3: 'chv',
    },
    {
      name: 'Cornish',
      nativeName: 'Kernewek',
      code: 'kw',
      code2: 'cor',
      code3: 'cor',
    },
    {
      name: 'Corsican',
      nativeName: 'corsu, lingua corsa',
      code: 'co',
      code2: 'cos',
      code3: 'cos',
    },
    {
      name: 'Croatian',
      nativeName: 'hrvatski jezik',
      code: 'hr',
      code2: 'hrv',
      code3: 'hrv',
    },
    {
      name: 'Czech',
      nativeName: 'čeština, český jazyk',
      code: 'cs',
      code2: 'ces',
      code3: 'cze',
    },
    {
      name: 'Danish',
      nativeName: 'dansk',
      code: 'da',
      code2: 'dan',
      code3: 'dan',
    },
    {
      name: 'Divehi, Dhivehi, Maldivian',
      nativeName: 'ދިވެހި',
      code: 'dv',
      code2: 'div',
      code3: 'div',
    },
    {
      name: 'Dutch, Flemish',
      nativeName: 'Nederlands, Vlaams',
      code: 'nl',
      code2: 'nld',
      code3: 'dut',
    },
    {
      name: 'Dzongkha',
      nativeName: 'རྫོང་ཁ',
      code: 'dz',
      code2: 'dzo',
      code3: 'dzo',
    },
    {
      name: 'English',
      nativeName: 'English',
      code: 'en',
      code2: 'eng',
      code3: 'eng',
    },
    {
      name: 'Ewe',
      nativeName: 'Eʋegbe',
      code: 'ee',
      code2: 'ewe',
      code3: 'ewe',
    },
    {
      name: 'Faroese',
      nativeName: 'føroyskt',
      code: 'fo',
      code2: 'fao',
      code3: 'fao',
    },
    {
      name: 'Fijian',
      nativeName: 'vosa Vakaviti',
      code: 'fj',
      code2: 'fij',
      code3: 'fij',
    },
    {
      name: 'Finnish',
      nativeName: 'suomi, suomen kieli',
      code: 'fi',
      code2: 'fin',
      code3: 'fin',
    },
    {
      name: 'French',
      nativeName: 'français, langue française',
      code: 'fr',
      code2: 'fra',
      code3: 'fre',
    },
    {
      name: 'Galician',
      nativeName: 'Galego',
      code: 'gl',
      code2: 'glg',
      code3: 'glg',
    },
    {
      name: 'Georgian',
      nativeName: 'ქართული',
      code: 'ka',
      code2: 'kat',
      code3: 'geo',
    },
    {
      name: 'German',
      nativeName: 'Deutsch',
      code: 'de',
      code2: 'deu',
      code3: 'ger',
    },
    {
      name: 'Greek (modern)',
      nativeName: 'ελληνικά',
      code: 'el',
      code2: 'ell',
      code3: 'gre',
    },
    {
      name: 'Gujarati',
      nativeName: 'ગુજરાતી',
      code: 'gu',
      code2: 'guj',
      code3: 'guj',
    },
    {
      name: 'Haitian, Haitian Creole',
      nativeName: 'Kreyòl ayisyen',
      code: 'ht',
      code2: 'hat',
      code3: 'hat',
    },
    {
      name: 'Hausa',
      nativeName: '(Hausa) هَوُسَ',
      code: 'ha',
      code2: 'hau',
      code3: 'hau',
    },
    {
      name: 'Herero',
      nativeName: 'Otjiherero',
      code: 'hz',
      code2: 'her',
      code3: 'her',
    },
    {
      name: 'Hindi',
      nativeName: 'हिन्दी, हिंदी',
      code: 'hi',
      code2: 'hin',
      code3: 'hin',
    },
    {
      name: 'Hiri Motu',
      nativeName: 'Hiri Motu',
      code: 'ho',
      code2: 'hmo',
      code3: 'hmo',
    },
    {
      name: 'Hungarian',
      nativeName: 'magyar',
      code: 'hu',
      code2: 'hun',
      code3: 'hun',
    },
    {
      name: 'Irish',
      nativeName: 'Gaeilge',
      code: 'ga',
      code2: 'gle',
      code3: 'gle',
    },
    {
      name: 'Igbo',
      nativeName: 'Asụsụ Igbo',
      code: 'ig',
      code2: 'ibo',
      code3: 'ibo',
    },
    {
      name: 'Icelandic',
      nativeName: 'Íslenska',
      code: 'is',
      code2: 'isl',
      code3: 'ice',
    },
    {
      name: 'Italian',
      nativeName: 'Italiano',
      code: 'it',
      code2: 'ita',
      code3: 'ita',
    },
    {
      name: 'Japanese',
      nativeName: '日本語 (にほんご)',
      code: 'ja',
      code2: 'jpn',
      code3: 'jpn',
    },
    {
      name: 'Javanese',
      nativeName: 'ꦧꦱꦗꦮ, Basa Jawa',
      code: 'jv',
      code2: 'jav',
      code3: 'jav',
    },
    {
      name: 'Kalaallisut, Greenlandic',
      nativeName: 'kalaallisut, kalaallit oqaasii',
      code: 'kl',
      code2: 'kal',
      code3: 'kal',
    },
    {
      name: 'Kannada',
      nativeName: 'ಕನ್ನಡ',
      code: 'kn',
      code2: 'kan',
      code3: 'kan',
    },
    {
      name: 'Kashmiri',
      nativeName: 'कश्मीरी, كشميري',
      code: 'ks',
      code2: 'kas',
      code3: 'kas',
    },
    {
      name: 'Kazakh',
      nativeName: 'қазақ тілі',
      code: 'kk',
      code2: 'kaz',
      code3: 'kaz',
    },
    {
      name: 'Kikuyu, Gikuyu',
      nativeName: 'Gĩkũyũ',
      code: 'ki',
      code2: 'kik',
      code3: 'kik',
    },
    {
      name: 'Kinyarwanda',
      nativeName: 'Ikinyarwanda',
      code: 'rw',
      code2: 'kin',
      code3: 'kin',
    },
    {
      name: 'Kirghiz, Kyrgyz',
      nativeName: 'Кыргызча, Кыргыз тили',
      code: 'ky',
      code2: 'kir',
      code3: 'kir',
    },
    {
      name: 'Korean',
      nativeName: '한국어',
      code: 'ko',
      code2: 'kor',
      code3: 'kor',
    },
    {
      name: 'Kuanyama, Kwanyama',
      nativeName: 'Kuanyama',
      code: 'kj',
      code2: 'kua',
      code3: 'kua',
    },
    {
      name: 'Luxembourgish, Letzeburgesch',
      nativeName: 'Lëtzebuergesch',
      code: 'lb',
      code2: 'ltz',
      code3: 'ltz',
    },
    {
      name: 'Ganda',
      nativeName: 'Luganda',
      code: 'lg',
      code2: 'lug',
      code3: 'lug',
    },
    {
      name: 'Limburgan, Limburger, Limburgish',
      nativeName: 'Limburgs',
      code: 'li',
      code2: 'lim',
      code3: 'lim',
    },
    {
      name: 'Lingala',
      nativeName: 'Lingála',
      code: 'ln',
      code2: 'lin',
      code3: 'lin',
    },
    {
      name: 'Lao',
      nativeName: 'ພາສາລາວ',
      code: 'lo',
      code2: 'lao',
      code3: 'lao',
    },
    {
      name: 'Lithuanian',
      nativeName: 'lietuvių kalba',
      code: 'lt',
      code2: 'lit',
      code3: 'lit',
    },
    {
      name: 'Manx',
      nativeName: 'Gaelg, Gailck',
      code: 'gv',
      code2: 'glv',
      code3: 'glv',
    },
    {
      name: 'Macedonian',
      nativeName: 'македонски јазик',
      code: 'mk',
      code2: 'mkd',
      code3: 'mac',
    },
    {
      name: 'Malayalam',
      nativeName: 'മലയാളം',
      code: 'ml',
      code2: 'mal',
      code3: 'mal',
    },
    {
      name: 'Maltese',
      nativeName: 'Malti',
      code: 'mt',
      code2: 'mlt',
      code3: 'mlt',
    },
    {
      name: 'Marshallese',
      nativeName: 'Kajin M̧ajeļ',
      code: 'mh',
      code2: 'mah',
      code3: 'mah',
    },
    {
      name: 'Navajo, Navaho',
      nativeName: 'Diné bizaad',
      code: 'nv',
      code2: 'nav',
      code3: 'nav',
    },
    {
      name: 'Nepali',
      nativeName: 'नेपाली',
      code: 'ne',
      code2: 'nep',
      code3: 'nep',
    },
    {
      name: 'Ndonga',
      nativeName: 'Owambo',
      code: 'ng',
      code2: 'ndo',
      code3: 'ndo',
    },
    {
      name: 'Occitan',
      nativeName: "occitan, lenga d'òc",
      code: 'oc',
      code2: 'oci',
      code3: 'oci',
    },
    {
      name: 'Ossetian, Ossetic',
      nativeName: 'ирон æвзаг',
      code: 'os',
      code2: 'oss',
      code3: 'oss',
    },
    {
      name: 'Panjabi, Punjabi',
      nativeName: 'ਪੰਜਾਬੀ',
      code: 'pa',
      code2: 'pan',
      code3: 'pan',
    },
    {
      name: 'Polish',
      nativeName: 'język polski, polszczyzna',
      code: 'pl',
      code2: 'pol',
      code3: 'pol',
    },
    {
      name: 'Portuguese',
      nativeName: 'Português',
      code: 'pt',
      code2: 'por',
      code3: 'por',
    },
    {
      name: 'Romansh',
      nativeName: 'Rumantsch Grischun',
      code: 'rm',
      code2: 'roh',
      code3: 'roh',
    },
    {
      name: 'Russian',
      nativeName: 'русский',
      code: 'ru',
      code2: 'rus',
      code3: 'rus',
    },
    {
      name: 'Sindhi',
      nativeName: 'सिन्धी, سنڌي، سندھی',
      code: 'sd',
      code2: 'snd',
      code3: 'snd',
    },
    {
      name: 'Northern Sami',
      nativeName: 'Davvisámegiella',
      code: 'se',
      code2: 'sme',
      code3: 'sme',
    },
    {
      name: 'Samoan',
      nativeName: "gagana fa'a Samoa",
      code: 'sm',
      code2: 'smo',
      code3: 'smo',
    },
    {
      name: 'Sango',
      nativeName: 'yângâ tî sängö',
      code: 'sg',
      code2: 'sag',
      code3: 'sag',
    },
    {
      name: 'Gaelic, Scottish Gaelic',
      nativeName: 'Gàidhlig',
      code: 'gd',
      code2: 'gla',
      code3: 'gla',
    },
    {
      name: 'Shona',
      nativeName: 'chiShona',
      code: 'sn',
      code2: 'sna',
      code3: 'sna',
    },
    {
      name: 'Sinhala, Sinhalese',
      nativeName: 'සිංහල',
      code: 'si',
      code2: 'sin',
      code3: 'sin',
    },
    {
      name: 'Slovak',
      nativeName: 'Slovenčina, Slovenský Jazyk',
      code: 'sk',
      code2: 'slk',
      code3: 'slo',
    },
    {
      name: 'Somali',
      nativeName: 'Soomaaliga, af Soomaali',
      code: 'so',
      code2: 'som',
      code3: 'som',
    },
    {
      name: 'Southern Sotho',
      nativeName: 'Sesotho',
      code: 'st',
      code2: 'sot',
      code3: 'sot',
    },
    {
      name: 'Spanish, Castilian',
      nativeName: 'Español',
      code: 'es',
      code2: 'spa',
      code3: 'spa',
    },
    {
      name: 'Sundanese',
      nativeName: 'Basa Sunda',
      code: 'su',
      code2: 'sun',
      code3: 'sun',
    },
    {
      name: 'Swedish',
      nativeName: 'Svenska',
      code: 'sv',
      code2: 'swe',
      code3: 'swe',
    },
    {
      name: 'Tamil',
      nativeName: 'தமிழ்',
      code: 'ta',
      code2: 'tam',
      code3: 'tam',
    },
    {
      name: 'Telugu',
      nativeName: 'తెలుగు',
      code: 'te',
      code2: 'tel',
      code3: 'tel',
    },
    {
      name: 'Tajik',
      nativeName: 'тоҷикӣ, toçikī, تاجیکی',
      code: 'tg',
      code2: 'tgk',
      code3: 'tgk',
    },
    {
      name: 'Thai',
      nativeName: 'ไทย',
      code: 'th',
      code2: 'tha',
      code3: 'tha',
    },
    {
      name: 'Tigrinya',
      nativeName: 'ትግርኛ',
      code: 'ti',
      code2: 'tir',
      code3: 'tir',
    },
    {
      name: 'Turkmen',
      nativeName: 'Türkmen, Түркмен',
      code: 'tk',
      code2: 'tuk',
      code3: 'tuk',
    },
    {
      name: 'Tswana',
      nativeName: 'Setswana',
      code: 'tn',
      code2: 'tsn',
      code3: 'tsn',
    },
    {
      name: 'Tongan (Tonga Islands)',
      nativeName: 'Faka Tonga',
      code: 'to',
      code2: 'ton',
      code3: 'ton',
    },
    {
      name: 'Turkish',
      nativeName: 'Türkçe',
      code: 'tr',
      code2: 'tur',
      code3: 'tur',
    },
    {
      name: 'Tsonga',
      nativeName: 'Xitsonga',
      code: 'ts',
      code2: 'tso',
      code3: 'tso',
    },
    {
      name: 'Tatar',
      nativeName: 'татар теле, tatar tele',
      code: 'tt',
      code2: 'tat',
      code3: 'tat',
    },
    {
      name: 'Uighur, Uyghur',
      nativeName: 'ئۇيغۇرچە, Uyghurche',
      code: 'ug',
      code2: 'uig',
      code3: 'uig',
    },
    {
      name: 'Ukrainian',
      nativeName: 'Українська',
      code: 'uk',
      code2: 'ukr',
      code3: 'ukr',
    },
    {
      name: 'Urdu',
      nativeName: 'اردو',
      code: 'ur',
      code2: 'urd',
      code3: 'urd',
    },
    {
      name: 'Venda',
      nativeName: 'Tshivenḓa',
      code: 've',
      code2: 'ven',
      code3: 'ven',
    },
    {
      name: 'Vietnamese',
      nativeName: 'Tiếng Việt',
      code: 'vi',
      code2: 'vie',
      code3: 'vie',
    },
    {
      name: 'Walloon',
      nativeName: 'Walon',
      code: 'wa',
      code2: 'wln',
      code3: 'wln',
    },
    {
      name: 'Welsh',
      nativeName: 'Cymraeg',
      code: 'cy',
      code2: 'cym',
      code3: 'wel',
    },
    {
      name: 'Wolof',
      nativeName: 'Wollof',
      code: 'wo',
      code2: 'wol',
      code3: 'wol',
    },
    {
      name: 'Xhosa',
      nativeName: 'isiXhosa',
      code: 'xh',
      code2: 'xho',
      code3: 'xho',
    },
    {
      name: 'Yoruba',
      nativeName: 'Yorùbá',
      code: 'yo',
      code2: 'yor',
      code3: 'yor',
    },
    {
      name: 'Zulu',
      nativeName: 'isiZulu',
      code: 'zu',
      code2: 'zul',
      code3: 'zul',
    },
  ]